// extracted by mini-css-extract-plugin
export default {"no_arrow":"payOrderScreen_no_arrow__aXqBy"};